import { FilterState } from '../types';
import {
  AppVersionInfo,
  MessagingConfig,
  MondayIntegrationConfig,
} from '../types';

/** Intervalo base para alinhar a lista com o banco entre vários usuários (polling). */
export const EMPLOYEES_SYNC_INTERVAL_MS = 30000;

/** Teto do backoff exponencial quando o sync falha repetidamente. */
export const EMPLOYEES_SYNC_MAX_INTERVAL_MS = 300000;

/** Tamanho de página ao carregar rh_employees em lotes (Sprint 2 — escala). */
export const EMPLOYEE_FETCH_PAGE_SIZE = 200;

export const INITIAL_FILTERS: FilterState = {
  probation45: false,
  probation90: false,
  hasAbsences: false,
  isBirthday: false,
};

export const DEFAULT_APP_VERSION_INFO: AppVersionInfo = {
  versionLabel: '1.0.0',
  improvements: '',
  roadmap: '',
};

export const DEFAULT_MESSAGING_CONFIG: MessagingConfig = {
  enabled: false,
  baseUrl: '',
  apiKey: '',
  instance: '',
  birthdayEnabled: false,
  birthdayTemplate: 'Parabéns {nome}! A equipe deseja um feliz aniversário!',
  birthdaySendHour: 9,
  birthdaySendMinute: 0,
  generalEnabled: false,
  generalTemplate: 'Olá {nome}, tudo bem?',
};

export const DEFAULT_MONDAY_CONFIG: MondayIntegrationConfig = {
  enabled: false,
  boardId: '',
  triggerStatusColumnName: 'Status',
  triggerStatusDoneLabel: 'Feito',
  mondayApiToken: '',
  mondayColumnNameTitle: 'Nome',
  mondayColumnCompanyTitle: 'Empresa',
  mondayColumnRoleTitle: 'Função',
  mondayColumnCodeTitle: 'Código',
  mondayColumnBirthDateTitle: 'Data de Nascimento',
  mondayColumnWhatsappTitle: 'Whatsapp',
};

/** Estado do board antes do GET da API — sem seed no bundle (dados vêm do Postgres). */
export const BOARD_INITIAL = {
  items: {} as Record<string, import('../types').Employee[]>,
  columns: [] as { id: string; title: string; color?: string }[],
  costCenters: [] as import('../types').CostCenter[],
};
